(function (global) {
    define('MM/Components/Content/VideoBackground',[
        "jquery",
    ], function ($) {
        function VideoBackground(args) {

        }

        return function init(args) {
            return new VideoBackground(args);
        };
    });
})(this);
